import { render, staticRenderFns } from "./DeliveryAddress.vue?vue&type=template&id=1c073d73&"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports